import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlRemuneracaoADMRH = '/service/contabilidade/transparencia/admrh/'

class cargoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar() {
        return this.conex.post(urlRemuneracaoADMRH + 'cargos/')
    }
}

export default cargoService
